﻿import { UrlManager } from "../Utilities/UrlManager";
import { Utilities } from "../Utilities/Utilities";
import { SelectizeHelper } from "../Utilities/SelectizeHelper";
import { ApiClient } from "../ApiClient";
import { InViewPort } from "../Utilities/InViewPort";
import { CookieManager } from "../Utilities/CookieManager";

export class OnlineActivities {
    readonly templateDetailsCls: string = "template-details";
    readonly action: string = "GetOnlineActivityList";
    readonly containerCls: string = "online-activity-container";
    readonly contentCls: string = "online-activity-list-content";
    readonly loadingCls: string = "loading";
    readonly mobileBreakPoint: number = 768;

    urlManager: IUrlManager;
    utilities: Utilities;
    apiClient: IApiClient;
    selectizeHelper: SelectizeHelper;
    messageManager: IMessageManager;

    filterPrefixConfig: IFilterPrefixConfig;
    controllerUri: string;

    containerElement: HTMLElement = null;
    isQueryRunning: boolean = false;
    pageID: number = 1;
        
    constructor(apiClient: IApiClient, utilities: Utilities, urlManager: IUrlManager,
        messageManager: IMessageManager, selectizeHelper: SelectizeHelper, pageID: number, controllerUri: string,
        filterPrefixConfig: IFilterPrefixConfig) {
        let me: this = this,
            element: JQuery<HTMLElement> = jQuery(`.${me.containerCls}`);

        me.apiClient = apiClient;
        me.utilities = utilities;
        me.urlManager = urlManager;
        me.messageManager = messageManager;
        me.selectizeHelper = selectizeHelper;

        me.filterPrefixConfig = filterPrefixConfig;
        me.controllerUri = controllerUri;

        if (element.length === 1) {
            me.containerElement = element[0];
            me.initListeners();
            me.initScrollEvent();
            me.initItemClick();
            me.pageID = pageID;
        }

        jQuery(document).ready(() => {
            me.needToLoadNext();
            setTimeout((): void => { me.jumpToPage() }, 200);
        });
    }

    initScrollEvent(): void {
        let me: this = this,
            loadMore: Function = me.utilities.debounce((): void => {
                me.needToLoadNext();
            }, 100, false);

        window.onscroll = (ev: UIEvent): any => {
            loadMore();
        };
    }

    initListeners(): void {
        let me: this = this;

        jQuery(me.containerElement).find("#filters button").click((): void => {
            me.pageID = 1;
            me.getOnlineActivityList();
        });

        me.initPreviousNextListeners();
    }

    initPreviousNextListeners(): void {
        let me: this = this;

        jQuery(".btn.showmore").click(function (event: JQuery.Event): void {
            event.preventDefault();

            me.pageID++;
            me.getOnlineActivityList(false);
        });
    }

    initItemClick(): void {
        let me: this = this;

        jQuery(this.containerElement).find(`.${this.templateDetailsCls}`).off("click").click((event: JQuery.Event): void => {
            if (window.innerWidth < me.mobileBreakPoint) {
                me.utilities.expandMobile(event, jQuery(event.currentTarget));
            } else {
                me.openTemplateLink(jQuery(event.currentTarget));
            }
        });
    }

    openTemplateLink(container: JQuery<HTMLElement>): void {
        let templateLinkCls: string = "template-link",
            templateLink: JQuery<HTMLElement> = container.find(`.${templateLinkCls}`);

        if (templateLink.length > 0) {
            document.location.href = templateLink.attr('href');
        }
    }

    needToLoadNext(): void {
        let me: this = this,
            showMoreBtn: JQuery<HTMLElement> = jQuery(me.containerElement).find(".btn.showmore");
        /*
        if (!me.isQueryRunning && showMoreBtn.length === 1) {
            if (InViewPort.isAnyPartOfElementInViewport(showMoreBtn[0])) {
                me.pageID++;
                me.getWebinarsList(false);
            }
        }
        */
    }

    jumpToPage(): void {
        let me: this = this,
            pageElement: JQuery<HTMLElement> = jQuery(me.containerElement).find(`.online-activity-item.page-${me.pageID}:first`);

        if (me.pageID > 1 && pageElement.length > 0) {
            me.utilities.scrollToElement(pageElement);
        }
    }

    getOnlineActivityList(showFullScreenLoader: boolean = true): void {
        let me: this = this,
            categoryIDs: number[] = [];

        if (me.isQueryRunning) {
            return;
        }

        jQuery(me.containerElement).find("#filters input:checked").map(function (index, el) {
            categoryIDs.push(parseInt($(el).val() as string));
        });

        let loaderContainerElement: JQuery<HTMLElement> = showFullScreenLoader ? jQuery(me.containerElement) : jQuery(me.containerElement).find(".showmore-container"),
            ajaxUrl: string = me.constructAjaxUrl(categoryIDs, me.pageID),
            url: string = me.constructUrl(categoryIDs, me.pageID),
            apiCallback: IApiCallback = {
                success: (data: any): void => {
                    jQuery(me.containerElement).find(`.${me.contentCls}`).html(data.html);
                    me.urlManager.pushState(null, document.title, url);
                },
                complete: (textStatus: string) => {
                    jQuery(loaderContainerElement).removeClass(me.loadingCls);
                    me.isQueryRunning = false;
                },
                error: (textStatus: string, errorThrown: string) => {
                    me.messageManager.showApiErrorMessage(textStatus);
                },
                scope: me
            };

        me.isQueryRunning = true;
        jQuery(loaderContainerElement).addClass(me.loadingCls);
        me.apiClient.getData(ajaxUrl, apiCallback);
    }

    constructAjaxUrl(categoryIDs: number[], pageID: number): string {
        let me: this = this,
            url: string = `${me.controllerUri}/${me.action}/`,
            parts: string[] = [];

        if (categoryIDs.length > 0) {
            categoryIDs.forEach((value) => {
                parts.push("selectedCategoryIDs=" + value + "");
            });
        }

        if (pageID > 1) {
            parts.push("pageID=" + pageID);
        }

        if (parts.length > 0) {
            url += "?" + parts.join("&");
        }

        return me.urlManager.getAbsoluteUrl(url);
    }

    constructUrl(categoryIDs: number[], pageID: number): string {
        let me: this = this,
            url: string = `${me.controllerUri}`;

        // the order of this is important because the routes are set up in the same order
        if (categoryIDs.length > 0) {
            url += `/${me.filterPrefixConfig.category}-` + categoryIDs.join("-");
        }

        if (pageID > 1) {
            url += `/${me.filterPrefixConfig.paging}-${pageID}`;
        }

        return me.urlManager.getAbsoluteUrl(url);
    }
}

